import request from "../plugins/axios";

export function lossContact(params) {
    return request({
        url: '/workContact/lossContact',
        method: 'GET',
        params
    })
}
export function deleteContact(params) {
    return request({
        url: '/workContact/deleteContact',
        method: 'GET',
        params
    })
}
